import Cookie from 'js-cookie';
import { getCookieDomain } from '../constants/cookie';

interface IMultiuserToken {
  token: string;
  cartId: number;
}

interface IMultiuserTokenServiceProps {
  name: string;
  get(): IMultiuserToken | null;
  set(token: IMultiuserToken, domain: string): void;
  remove(): void;
}

export const MultiuserTokenService: IMultiuserTokenServiceProps = {
  name: 'multiuserCartToken',
  get() {
    const token = Cookie.get(decodeURIComponent(this.name));
    return token ? JSON.parse(token) : token;
  },

  set(params: object, domain: string, options?: Cookie.CookieAttributes) {
    Cookie.set(this.name, JSON.stringify(params), {
      httpOnly: false,
      domain,
      expires: new Date(Number.MAX_SAFE_INTEGER / 512),
      ...options,
    });
  },

  remove() {
    Cookie.remove(this.name, { domain: getCookieDomain().domain });
  },
};
